import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DirectionsRailwayFilledIcon(props: IconProps) {
    return <Icon {...props} iconKey={"directions_railway_filled"}/>
}
